(function () {
  'use strict';
  var R = window.ksira.routes;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: window.ksira.currency || 'INR', maximumFractionDigits: 2 }).format(cents / 100);
  };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- cart ---------- */
  var drawer = $('#cart-drawer');
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts)).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { throw new Error(d.description || d.message || 'Request failed'); } return d; });
    });
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; if (n > 0) { el.removeAttribute('data-zero'); } else { el.setAttribute('data-zero', ''); }
    });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) { return; }
    var ul = $('[data-cart-lines]', drawer); ul.textContent = '';
    cart.items.forEach(function (it) {
      var li = document.createElement('li'); li.className = 'line';
      var img = document.createElement('img'); img.width = 88; img.height = 88; img.loading = 'lazy';
      img.alt = it.featured_image && it.featured_image.alt ? it.featured_image.alt : it.product_title;
      img.src = it.featured_image && it.featured_image.url ? it.featured_image.url + (it.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=176' : '';
      var mid = document.createElement('div');
      var a = document.createElement('a'); a.className = 'line__name'; a.href = it.url; a.textContent = it.product_title; mid.appendChild(a);
      if (it.variant_title && it.variant_title !== 'Default Title') { var v = document.createElement('p'); v.textContent = it.variant_title; mid.appendChild(v); }
      var q = document.createElement('div'); q.className = 'qty';
      [['−', it.quantity - 1, 'Decrease quantity'], [null], ['+', it.quantity + 1, 'Increase quantity']].forEach(function (x) {
        if (x[0] === null) { var inp = document.createElement('input'); inp.value = it.quantity; inp.readOnly = true; inp.setAttribute('aria-label', 'Quantity'); q.appendChild(inp); return; }
        var b = document.createElement('button'); b.type = 'button'; b.textContent = x[0]; b.setAttribute('aria-label', x[2] + ' for ' + it.product_title);
        b.addEventListener('click', function () { change(it.key, x[1]); }); q.appendChild(b);
      });
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'rm'; rm.textContent = 'Remove'; rm.setAttribute('aria-label', 'Remove ' + it.product_title);
      rm.addEventListener('click', function () { change(it.key, 0); });
      var row = document.createElement('div'); row.style.cssText = 'display:flex;gap:12px;align-items:center;margin-top:8px;flex-wrap:wrap'; row.appendChild(q); row.appendChild(rm); mid.appendChild(row);
      var p = document.createElement('div'); p.className = 'line__price'; p.textContent = money(it.final_line_price);
      li.appendChild(img); li.appendChild(mid); li.appendChild(p); ul.appendChild(li);
    });
    $('[data-cart-empty]', drawer).hidden = cart.item_count > 0;
    $('[data-cart-foot]', drawer).hidden = cart.item_count === 0;
    $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
  }
  function change(key, qty) {
    return json(R.change + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (c) { renderCart(c); var s = $('[data-drawer-status]', drawer); if (s) { s.textContent = 'Cart updated. Subtotal ' + money(c.total_price); } if (document.body.classList.contains('template-cart')) { location.reload(); } })
      .catch(function (e) { var s = $('[data-drawer-status]', drawer); if (s) { s.textContent = e.message; } });
  }
  function openDrawer() {
    if (!drawer) { location.href = R.cart; return; }
    json(R.cartJs).then(function (c) { renderCart(c); if (!drawer.open) { drawer.showModal(); } });
  }
  if (drawer) {
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { drawer.close(); }); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) { drawer.close(); } });
  }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); openDrawer(); } }); });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-cart]'); if (!f) { return; }
    e.preventDefault();
    var btn = $('button[type=submit]', f), status = $('[data-cart-status]', f), label = btn.textContent;
    btn.disabled = true;
    var body = {}; new FormData(f).forEach(function (v, k) { body[k] = v; });
    json(R.add + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(body.id), quantity: Number(body.quantity || 1) }] }) })
      .then(function () { btn.textContent = 'Added'; if (status) { status.textContent = 'Added to cart.'; } $$('[data-cart-count]').forEach(function (c) { c.classList.remove('toast'); void c.offsetWidth; c.classList.add('toast'); }); return json(R.cartJs); })
      .then(function (c) { renderCart(c); if (drawer && !drawer.open) { drawer.showModal(); } })
      .catch(function (err) { if (status) { status.textContent = err.message; } btn.textContent = 'Could not add'; })
      .then(function () { setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500); });
  });

  /* quantity steppers on product + cart pages */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) { return; }
    var input = $('input', b.parentNode); var n = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-qty')));
    input.value = n;
  });
  $$('[data-cart-line]').forEach(function (row) {
    $$('[data-line-qty]', row).forEach(function (b) { b.addEventListener('click', function () { change(row.getAttribute('data-cart-line'), Number(b.getAttribute('data-line-qty'))); }); });
  });

  /* ---------- header ---------- */
  var mb = $('[data-menu-btn]'), mnav = $('[data-mnav]');
  if (mb && mnav) {
    var shutTimer = 0;
    var finishMenu = function () {
      clearTimeout(shutTimer);
      mnav.classList.remove('is-closing');
      if (mnav.open) { mnav.close(); }
      document.documentElement.classList.remove('is-locked');
      mb.setAttribute('aria-expanded', 'false');
    };
    var closeMenu = function () {
      if (!mnav.open || mnav.classList.contains('is-closing')) { return; }
      if (reduce) { finishMenu(); return; }
      mnav.classList.add('is-closing');
      shutTimer = setTimeout(finishMenu, 380);
    };
    mb.addEventListener('click', function () {
      var r = mb.getBoundingClientRect();
      mnav.style.setProperty('--ox', (r.left + r.width / 2) + 'px');
      mnav.style.setProperty('--oy', (r.top + r.height / 2) + 'px');
      mnav.showModal();
      document.documentElement.classList.add('is-locked');
      mb.setAttribute('aria-expanded', 'true');
    });
    $$('[data-mnav-close]', mnav).forEach(function (b) { b.addEventListener('click', closeMenu); });
    $$('a', mnav).forEach(function (a) { a.addEventListener('click', closeMenu); });
    mnav.addEventListener('cancel', function (e) { e.preventDefault(); closeMenu(); });
    mnav.addEventListener('close', finishMenu);
    window.addEventListener('pageshow', finishMenu);
    window.matchMedia('(min-width:821px)').addEventListener('change', function (e) { if (e.matches) { finishMenu(); } });
  }
  var sb = $('[data-search-btn]'), sbar = $('[data-searchbar]');
  if (sb && sbar) { sb.addEventListener('click', function () { var h = sbar.hidden; sbar.hidden = !h; sb.setAttribute('aria-expanded', h); if (h) { $('input', sbar).focus(); } }); }

  /* ---------- hero: tilt + static fallback ---------- */
  var hero = $('[data-hero]');
  if (hero) {
    var weak = !(window.CSS && CSS.supports('transform-style', 'preserve-3d')) || (navigator.deviceMemory && navigator.deviceMemory <= 2) || (navigator.connection && navigator.connection.saveData);
    if (weak) { hero.classList.add('hero--static'); }
    else if (!reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      var scene = $('[data-scene]', hero), raf = 0;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { scene.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg'); scene.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg'); });
      });
      hero.addEventListener('pointerleave', function () { scene.style.setProperty('--ry', '0deg'); scene.style.setProperty('--rx', '0deg'); });
    }
  }

  /* ---------- journey ---------- */
  $$('[data-journey]').forEach(function (j) {
    var slides = $$('[data-slide]', j), arts = $$('[data-art]', j), chips = $$('[data-chip]', j), i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      arts.forEach(function (a, k) { a.classList.toggle('is-on', k === i); });
      chips.forEach(function (c, k) { c.setAttribute('aria-pressed', k === i); });
      j.style.setProperty('--c', slides[i].getAttribute('data-color'));
      var live = $('[data-journey-live]', j); if (live) { live.textContent = slides[i].getAttribute('data-name'); }
    }
    chips.forEach(function (c, k) { c.addEventListener('click', function () { go(k); }); });
    var p = $('[data-prev]', j), n = $('[data-next]', j);
    if (p) { p.addEventListener('click', function () { go(i - 1); }); }
    if (n) { n.addEventListener('click', function () { go(i + 1); }); }
    j.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(i + 1); } if (e.key === 'ArrowLeft') { go(i - 1); } });
    var sx = null; j.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    j.addEventListener('touchend', function (e) { if (sx === null) { return; } var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 48) { go(i + (dx < 0 ? 1 : -1)); } sx = null; });
    var pack = $('[data-tilt]', j);
    if (pack && !reduce) {
      j.querySelector('[data-art-wrap]').addEventListener('pointermove', function (e) {
        var r = e.currentTarget.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        pack.style.transform = 'rotateY(' + (x * 24).toFixed(1) + 'deg) rotateX(' + (-y * 12).toFixed(1) + 'deg)';
      });
      j.querySelector('[data-art-wrap]').addEventListener('pointerleave', function () { pack.style.transform = ''; });
    }
    go(0);
  });

  /* ---------- reveal (story only) ---------- */
  var rv = $$('.reveal');
  if (rv.length && 'IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: .2 });
    rv.forEach(function (el, k) { el.style.transitionDelay = (k % 3) * 90 + 'ms'; io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- collection sort/filter + gallery ---------- */
  var sort = $('[data-sort]');
  if (sort) { sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); }); }
  $$('[data-filter-form] input').forEach(function (i) { i.addEventListener('change', function () { i.form.submit(); }); });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-thumb]') : null;
    if (!t) return;
    var main = $('[data-main-img]');
    if (!main) return;
    var src = t.getAttribute('data-src');
    var srcset = t.getAttribute('data-srcset');
    var alt = t.getAttribute('data-alt');
    if (srcset) {
      main.setAttribute('srcset', srcset);
    } else {
      main.removeAttribute('srcset');
    }
    main.removeAttribute('sizes');
    main.removeAttribute('width');
    main.removeAttribute('height');
    if (src) main.src = src;
    if (alt) main.alt = alt;
    $$('[data-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
    t.setAttribute('aria-current', 'true');
  });

  fetch(R.cartJs).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
})();
